import { Typography } from '@yanolja-rnd/ya-com-core'
import { Icon_error } from '@yanolja-rnd/ya-com-system-icon'
import styled from '~/app/components/styled'

const WarningNotice = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.yaorange};
  svg {
    flex: 0 0 1.6rem;
  }
  span {
    word-break: keep-all;
    ${Typography('body2').bold};
    margin-left: 0.2rem;
    margin-top: 0.1rem;
  }
`
const ErrorIcon = styled(Icon_error)`
  path {
    fill: ${({ theme }) => theme.color.yaorange};
  }
`

/**
 * 레저 응답실패 텍스트
 */
const FetchFailText = () => (
  <WarningNotice>
    <ErrorIcon size={1.6} unit="rem" />
    <span>정보를 불러오지 못했어요.</span>
  </WarningNotice>
)

export default FetchFailText
